import React from 'react';
import { navigate } from 'gatsby';
import {
  RoamingFAQIcon,
  RoamingOKIcon,
  RoamingInfoIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/help';
import {
  ActionButtonStyled,
  RoamingContainerStyled,
  RoamingContentStyled,
  RoamingHeaderStyled,
  ActionButtonWrapperStyled,
} from './styles/RoamingStyled';
import { redirectInternalOrExternal } from '../../../helpers/Redirect';
import { useGlobalData } from '../../../contextProvider/GlobalDataContext';

const actionButtons = [
  {
    name: 'TipsNavegacion',
    component: (
      <ActionButtonStyled
        icon={RoamingInfoIcon}
        onClick={() => redirectInternalOrExternal('https://www.wom.cl/roaming')}
        upperTitle="Tips de navegación"
      />
    ),
  },
  {
    name: 'ActivaRoaming',
    component: (
      <ActionButtonStyled
        icon={RoamingOKIcon}
        onClick={() => redirectInternalOrExternal('/roaming')}
        upperTitle="Activa tu roaming"
      />
    ),
  },
  {
    name: 'PreguntasFrecuentes',
    component: (
      <ActionButtonStyled
        icon={RoamingFAQIcon}
        onClick={() => {
          navigate(`/ayuda/centro-de-ayuda/roaming`, {
            state: {
              iframe:
                'https://www.wom.cl/centro-de-ayuda/category/roaming/?miWomView=1&utm_source=miwom&utm_medium=CDA&utm_campaign=Boton_Roaming',
              title: 'Roaming',
              height: 2100,
            },
          });
        }}
        upperTitle="Preguntas frecuentes"
      />
    ),
  },
];

const Roaming = () => {
  const { roaming } = useGlobalData();
  if (!roaming.mostrar) return null;
  return (
    <RoamingContainerStyled>
      <RoamingHeaderStyled>
        <h1>Roaming</h1>
        <h2>Revisa estos consejos antes de viajar</h2>
      </RoamingHeaderStyled>
      <RoamingContentStyled>
        {actionButtons.map(({ name, component }, index) => (
          <ActionButtonWrapperStyled
            centerbutton={
              index + 1 === actionButtons.length && index % 3 === 0 ? 1 : 0
            }
            key={name}
          >
            {component}
          </ActionButtonWrapperStyled>
        ))}
      </RoamingContentStyled>
    </RoamingContainerStyled>
  );
};

export default Roaming;
